import styled from 'styled-components'

export const Container = styled.div`
  .vjs-theme-forest {
    --vjs-theme-forest--primary: #ff6600 !important;
  }
`
